import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';
import { PortvilleBill } from '../types/portvilleBilling';

/**
 * Firestore 문서를 PortvilleBill 객체로 변환하는 유틸리티 함수
 */
export function transformBillDocument(doc: QueryDocumentSnapshot<DocumentData>): PortvilleBill {
  const data = doc.data();
  
  return {
    id: doc.id,
    ...data,
    billingPeriod: {
      ...data.billingPeriod,
      startDate: data.billingPeriod?.startDate?.toDate() || new Date(),
      endDate: data.billingPeriod?.endDate?.toDate() || new Date()
    },
    billItems: {
      ...data.billItems,
      // 기존 청구서에 미납금과 가산금 필드가 없으면 0으로 초기화
      overdueAmount: data.billItems?.overdueAmount || 0,
      overduePenalty: data.billItems?.overduePenalty || 0,
      expectedPenalty: data.billItems?.expectedPenalty || 0
    },
    issuedDate: data.issuedDate?.toDate() || new Date(),
    dueDate: data.dueDate?.toDate() || new Date(),
    paidDate: data.paidDate?.toDate(),
    createdAt: data.createdAt?.toDate() || new Date(),
    updatedAt: data.updatedAt?.toDate() || new Date()
  } as PortvilleBill;
}

/**
 * 청구서 목록을 호실번호순으로 정렬
 */
export function sortBillsByRoomNumber(bills: PortvilleBill[]): PortvilleBill[] {
  return bills.sort((a, b) => a.roomNumber.localeCompare(b.roomNumber));
}

/**
 * 청구서 목록을 연도/월 내림차순으로 정렬
 */
export function sortBillsByPeriodDesc(bills: PortvilleBill[]): PortvilleBill[] {
  return bills.sort((a, b) => {
    if (a.billingPeriod.year !== b.billingPeriod.year) {
      return b.billingPeriod.year - a.billingPeriod.year;
    }
    return b.billingPeriod.month - a.billingPeriod.month;
  });
}

/**
 * 연도/월로 청구서 필터링
 */
export function filterBillsByPeriod(bills: PortvilleBill[], year: number, month: number): PortvilleBill[] {
  return bills.filter(bill => 
    bill.billingPeriod?.year === year && bill.billingPeriod?.month === month
  );
}

/**
 * 호실 ID로 청구서 필터링
 */
export function filterBillsByRoomId(bills: PortvilleBill[], roomId: string): PortvilleBill[] {
  return bills.filter(bill => bill.roomId === roomId);
}
